<mat-dialog-content>
  {{ message }}
  @if (navigateToReference) {
    <mat-action-list>
      @for (reference of references; track reference) {
        <mat-list-item
          (click)="referenceClick(reference.path)"
          >
          <a>{{ reference.name }}</a>
        </mat-list-item>
      }
    </mat-action-list>
  }

  @if (!navigateToReference) {
    <mat-list>
      @for (reference of references; track reference) {
        <mat-list-item
          (click)="referenceClick(reference.path)"
          >
          <a>{{ reference.name }}</a>
        </mat-list-item>
      }
    </mat-list>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close tabindex="-1">Cancel</button>
</mat-dialog-actions>
